import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { verticalList } from "@/data/verticals";

const productLinks = [
  { to: "/product/office", label: "ServiTrex office" },
  { to: "/product/field", label: "TrexField" },
  { to: "/pricing", label: "Pricing" },
  { to: "/signup", label: "Sign up" },
];

const companyLinks = [
  { to: "/about", label: "About" },
  { to: "/demo", label: "Request a demo" },
  { to: "/legal/terms", label: "Terms" },
  { to: "/legal/privacy", label: "Privacy" },
];

export function Footer() {
  return (
    <footer className="mt-auto border-t border-border bg-ink text-fg-inverse">
      <div className="container-page grid gap-10 py-14 md:grid-cols-12">
        <div className="md:col-span-5">
          <Logo className="text-fg-inverse [&_span]:text-fg-inverse [&_.text-teal-deep]:text-teal" />
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-fg-inverse/70">
            The multi-tenant field-service platform for home-service companies.
            One system for office operations, TrexField in the truck, and AI voice
            on the phones.
          </p>
        </div>

        <div className="grid gap-8 sm:grid-cols-3 md:col-span-7">
          <div>
            <h2 className="font-display text-sm font-semibold tracking-normal text-teal">
              Product
            </h2>
            <ul className="mt-3 space-y-2 text-sm text-fg-inverse/75">
              {productLinks.map((link) => (
                <li key={link.to}>
                  <Link className="hover:text-fg-inverse" to={link.to}>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h2 className="font-display text-sm font-semibold tracking-normal text-teal">
              Verticals
            </h2>
            <ul className="mt-3 space-y-2 text-sm text-fg-inverse/75">
              {verticalList.map((vertical) => (
                <li key={vertical.slug}>
                  <Link
                    className="hover:text-fg-inverse"
                    to={`/verticals/${vertical.slug}`}
                  >
                    {vertical.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h2 className="font-display text-sm font-semibold tracking-normal text-teal">
              Company
            </h2>
            <ul className="mt-3 space-y-2 text-sm text-fg-inverse/75">
              {companyLinks.map((link) => (
                <li key={link.to}>
                  <Link className="hover:text-fg-inverse" to={link.to}>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-page flex flex-col gap-2 py-5 text-xs text-fg-inverse/55 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 ServiTrex, a Cognautic company</p>
          <p>Built for HVAC, plumbing, electrical, roofing, and multi-trade teams.</p>
        </div>
      </div>
    </footer>
  );
}
